export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { 
    legend: { display: false },
    tooltip: {
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      titleFont: { size: 11, weight: 'bold' },
      bodyFont: { size: 11 },
      padding: 10,
      cornerRadius: 6,
      displayColors: false,
    }
  },
  scales: { 
    y: { 
      beginAtZero: true,
      grid: { 
        color: 'rgba(0, 0, 0, 0.05)',
        drawTicks: false,
        tickBorderDash: [4, 4],
        borderDash: [4, 4]
      }, 
      ticks: { 
        font: { size: 10, family: "'DM Sans', sans-serif" }, 
        color: '#94a3b8'
      }, 
      border: { display: false } 
    }, 
    x: { 
      grid: { 
        color: 'rgba(0, 0, 0, 0.05)',
        borderDash: [4, 4]
      }, 
      ticks: { 
        font: { size: 10, family: "'DM Sans', sans-serif" }, 
        color: '#94a3b8'
      }, 
      border: { display: false } 
    } 
  },
};

export const DOUGHNUT_OPTIONS = {
  responsive: true,
  plugins: { 
    legend: { position: 'bottom', labels: { boxWidth: 10, font: { size: 11 } } } 
  },
  cutout: '65%',
};

export const BAR_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      titleFont: { size: 11, weight: 'bold' },
      bodyFont: { size: 11 },
      padding: 10,
      cornerRadius: 6,
      displayColors: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      grid: { color: 'rgba(0,0,0,0.05)', borderDash: [4, 4] },
      ticks: { 
        font: { size: 10, family: "'DM Sans', sans-serif" }, 
        color: '#94a3b8', 
        stepSize: 10,
        precision: 0
      },
      border: { display: false },
    },
    x: {
      grid: { display: false },
      ticks: { font: { size: 9, family: "'DM Sans', sans-serif" }, color: '#94a3b8' },
      border: { display: false },
    },
  },
  borderRadius: 6,
  barPercentage: 0.65,
};





